const GreenCoinIcon = () => {
  return (
    <svg
      width="142"
      height="142"
      viewBox="0 0 142 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60.5017 134.725C92.47 143.139 125.357 123.664 134.125 91.5193C142.894 59.3742 124.326 26.3563 92.3577 17.9421C60.3894 9.52794 27.5026 29.0027 18.734 61.1478C9.96551 93.2929 28.5335 126.311 60.5017 134.725Z"
        fill="#021024"
        fillOpacity="0.1"
      />
      <path
        d="M57.556 128.7C88.0382 136.723 119.556 118.168 127.976 87.2986C136.397 56.429 118.547 24.8803 88.0644 16.8573C57.5823 8.83427 26.0648 27.3891 17.6442 58.2587C9.22357 89.1284 27.0739 120.677 57.556 128.7Z"
        fill="#8DBBBB"
        stroke="#079391"
        strokeWidth="2"
      />
      <path
        d="M53.9362 125.143C84.4183 133.166 115.936 114.612 124.356 83.742C132.777 52.8723 114.927 21.3237 84.4446 13.3007C53.9624 5.27763 22.4449 23.8324 14.0243 54.7021C5.6037 85.5718 23.454 117.12 53.9362 125.143Z"
        fill="#7DC1B9"
        stroke="#079391"
        strokeWidth="2"
      />
      <path
        d="M56.7466 114.839C81.442 121.339 107 106.153 113.866 80.981C120.732 55.8091 106.329 30.105 81.6334 23.605C56.9381 17.1051 31.3805 32.2913 24.5141 57.4632C17.6477 82.635 32.0513 108.339 56.7466 114.839Z"
        fill="#CAEAE9"
        stroke="#079391"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.795 37.5665C97.8214 33.2115 91.8053 29.9203 84.9904 28.1266C60.8506 21.7729 35.8282 36.6137 29.1013 61.2745C24.7609 77.1861 29.0976 93.2982 39.2053 104.435C26.5613 93.3633 20.6535 75.4166 25.4814 57.7178C32.2083 33.0571 57.2307 18.2163 81.3704 24.5699C89.9347 26.8241 97.2373 31.4431 102.795 37.5665Z"
        fill="#EBF3FF"
      />
      <path
        d="M56.52 17.7996C39.7069 22.3579 26.1643 34.6593 20.1182 50.5527"
        stroke="#CBECEC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M97.4065 113.672C103.79 109.503 109.224 104.042 113.322 97.6699"
        stroke="#CBECEC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.42 26.5508C38.42 26.5508 32.9899 30.1067 29.3699 35.4407"
        stroke="#FEFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.6598 35.4404C45.6598 35.4404 40.2297 38.9964 36.6096 44.3303"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GreenCoinIcon;
